import type { State } from './vuex';
import type { LtiRegistrationSummary } from './state';

export default {
  setActiveRegistrations(state: State, registrations: LtiRegistrationSummary[]): void {
    state.activeRegistrations = registrations;
  },
};
